export default __webpack_public_path__ + "static/media/Musical-Note-Screen.961a3549.jpg";